import axios from 'axios'


let urlIn = null
let url = window.location.href
if (url.includes("http://cspda.lcyjfz.com")) {
  urlIn = 'http://cs.lcyjfz.com'
} else if (url.includes("http://pda.lcyjfz.com/")) {
  urlIn = 'http://www.lcyjfz.com'
} else {
  urlIn = 'http://cs.lcyjfz.com'
}
// export const urlIndex = urlIn

let base = window.location.origin;
let requestUrl = ""
if (base.includes('localhost')) {
  //requestUrl = 'http://cspda.lcyjfz.com'
  requestUrl = 'https://adminzjds.runfeinet.com'
} else {
  requestUrl = base
}
// axios.get(`http://www.lcyjfz.com/api/init?url=${requestUrl}`).then(res => {
//   // window.localStorage.setItem('pdaBASEURL', 'https://adminlianrun.runfeinet.com' + '/api')
//     window.localStorage.setItem('pdaBASEURL', 'https://adminlw.runfeinet.com' + '/api')
// })
 window.localStorage.setItem('pdaBASEURL', 'https://adminzjds.runfeinet.com' + '/api')
export const apiobj = {
  packingOne: '/business/packingOne',
  BUSSINESS_LOGIN: '/business/pdaLogin', // pda登录
  doPacking: '/business/doPacking', // pda装修单装箱
  packingEdit: '/business/packingEdit', // pda编辑装箱单
  packingDetail: '/business/packing_detail',
  chukuGoodsorder: '/business/chukuGoodsorder',
  packingList: '/business/packingList',
  packingDel: '/business/packingDel',
  packingOrder: '/business/packingOrder',
  backPacking: '/business/backPacking',
  outOne: '/business/outOne',
  doOut: '/business/doOut',
  outEdit: '/business/outEdit',
  backOut: '/business/backOut',
  out_detail: '/business/out_detail',
  outDel: '/business/outDel',
  out_List: '/business/outList',
  xhOut: '/business/xhOut',
  xhOuts: '/business/xhOuts',
  doXhout: '/business/doXhout',
  backXhout: '/business/backXhout',
  editXhout: '/business/editXhout',
  delXhout: '/business/delXhout',
  OutXHList: '/business/OutXHList', //装箱单列表
  out_xhdetail: '/business/out_xhdetail',
  zdXHout: "/business/zdXHout", //明细码扫码
  getNormsware: "/business/getNormsware", //扫描卷号
  checkdoPacking: "/business/checkdoPacking", // 检查是否有重复的明细码
  isGoods: "/business/isGoods", // 参数 goods 货位 判断箱号接口
  vouchOne: "/business/vouchOne", // 参数 goods 货位 gck_number 明细码
  doVouch: "/business/doVouch", //装箱
  outRcs: "/business/outRcs", // 出库 扫明细码
  doRcsout: "/business/doRcsout", // 出库
  inPack: "/inPack", // 入箱扫码 pack_num 
  packitem: "/business/packItem", // 查询 无参数
  // getMeters:"/"
  packList: "/business/packList", // 列表页 参数 number 单好 detail
  packMx: "/business/packMx", // 查看接口 参数 id
  chuKong: '/business/chuKong', // 出空箱接口
  chuXiang: '/business/chuXiang', // 出箱接口
  carPlay:"/business/carPlay", // 车取货
  carRelease:"/business/carRelease", // 车放货
  carEmpty:"/business/carEmpty", // 车放空
  packAfter:'/business/packAfter',
  packnoAfter:"/business/packnoAfter",
  WarehouseStocking:"/WarehouseStocking",//机器卷号出入仓
  WarehouseOutbound:"/WarehouseOutbound", //机器明细码和货号出仓
  WarehouseInScanReel:"/WarehouseInScanReel",//扫描卷号
  WarehouseOutQuery:"/WarehouseOutQuery",//扫描明细码和货号
  WarehouseStockingCancel:"/WarehouseStockingCancel",//消仓
  WarehouseOutboundCancel:"/WarehouseOutboundCancel",//返仓
  ClothAdjustment:"/business/ClothAdjustment",//布料调整
  orderMxDyAll:"/admin/  orderMxDyAll",//水洗唛打印
  searchFabric:"/admin/numberAdd/",//布匹查询接口
  searchOrder:"/business/goodsorderList",//订单明细模式拣货列表
  Outstock:"/qhStatus",//订单明细模式拣货列表缺货
  doGoodsorder:"/business/doGoodsorder",//确认拣货
  outListZp:"/packingListQldf",//装箱单列表（准出库）
  outDetailZp:"packingAddQldf",//装箱单详情
  reelOut:"/reelPacking",//出库单扫描卷号
  chuOuts:"/doPackings",//面料出库
  backOuts:"/business/backOuts",//面料撤销出库
  doPandian:"/business/doPandian",//面料确认盘点
  backPandian:"/business/backPandian",//面料撤销盘点
  fingSupplier:"/fingSupplier", //退货供应商获取接口
  purbackAdd:"/purbackAdd", //退货保存接口
  isReel:'/isReel',//拣货判断接口
  rdVouch:'/rdVouch', //瑞动订单入库
  outPacking:'/outPacking', //瑞动出库装箱
  searchFabricRd:"/admin/numberAddrd",//瑞动布匹查询接口
  numberGetNorms:"/numberGetNorms", //货号查询
  mxmGetGoodsorder:"/mxmGetGoodsorder", //明细码获取
  mxmGetNormsware:'/mxmGetNormsware', //外贸明细码成品出库
  gckGoodsorder:'/gckGoodsorder', //瑞动
  reelGetGoodsorder:'/reelGetGoodsorder',
  goodsAllot:'/goodsAllot', //货位调拨
    fpVouch:'/fpVouch',//成品入库
  fpOut:'/fpOut',//成品出库
  processUserList:'/processUserList'
}
// 创建axios实例
const axiosRequest = axios.create({
  timeout: 50000 // 请求超时时间
})
export default axiosRequest